(function () {
  var ZOOM = 2.5;
  var box = null;
  var state = { images: [], index: 0, trigger: null, zoomed: false };

  function hiRes(img) {
    var src = img.getAttribute('src') || img.currentSrc || '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return /[?&]width=\d+/.test(src) ? src.replace(/([?&]width=)\d+/, '$12400') : src;
  }

  function build() {
    box = document.createElement('div');
    box.className = 'bb-lightbox';
    box.hidden = true;
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', 'Product image viewer');
    box.innerHTML =
      '<div class="bb-lightbox__track" data-lb-track></div>' +
      '<button type="button" class="bb-lightbox__btn bb-lightbox__close" data-lb-close aria-label="Close">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>' +
      '</button>' +
      '<button type="button" class="bb-lightbox__btn bb-lightbox__arrow bb-lightbox__arrow--prev" data-lb-prev aria-label="Previous image">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14.5 5.5 8 12l6.5 6.5"/></svg>' +
      '</button>' +
      '<button type="button" class="bb-lightbox__btn bb-lightbox__arrow bb-lightbox__arrow--next" data-lb-next aria-label="Next image">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9.5 5.5 16 12l-6.5 6.5"/></svg>' +
      '</button>' +
      '<p class="bb-lightbox__counter" data-lb-counter aria-live="polite"></p>' +
      '<p class="bb-lightbox__hint" data-lb-hint>' +
      (window.matchMedia('(hover: hover)').matches ? 'Click' : 'Tap') +
      ' image to zoom</p>';
    document.body.appendChild(box);

    var track = box.querySelector('[data-lb-track]');

    box.querySelector('[data-lb-close]').addEventListener('click', close);
    box.querySelector('[data-lb-prev]').addEventListener('click', function () { go(state.index - 1); });
    box.querySelector('[data-lb-next]').addEventListener('click', function () { go(state.index + 1); });

    box.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') close();
      if (event.key === 'ArrowLeft') go(state.index - 1);
      if (event.key === 'ArrowRight') go(state.index + 1);
    });

    var scrollTimer;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var i = track.clientWidth ? Math.round(track.scrollLeft / track.clientWidth) : 0;
        if (i !== state.index) {
          unzoom();
          state.index = i;
          updateCounter();
        }
      }, 80);
    });

    track.addEventListener('click', function (event) {
      var img = event.target.closest('.bb-lightbox__img');
      if (img && !state.zoomed && !onPicture(img, event.clientX, event.clientY)) img = null;
      if (!img) {
        if (!state.zoomed) close();
        return;
      }
      if (state.zoomed) {
        unzoom();
      } else {
        setOrigin(img, event.clientX, event.clientY);
        img.classList.add('is-zoomed');
        box.classList.add('is-zoomed');
        state.zoomed = true;
      }
    });

    track.addEventListener('mousemove', function (event) {
      var img = event.target.closest('.bb-lightbox__img');
      if (!img) return;
      if (state.zoomed) {
        setOrigin(img, event.clientX, event.clientY);
      } else {
        img.style.cursor = onPicture(img, event.clientX, event.clientY) ? 'zoom-in' : 'default';
      }
    });

    track.addEventListener(
      'touchmove',
      function (event) {
        if (!state.zoomed || event.touches.length !== 1) return;
        var img = track.querySelector('.bb-lightbox__img.is-zoomed');
        if (!img) return;
        event.preventDefault();
        setOrigin(img, event.touches[0].clientX, event.touches[0].clientY);
      },
      { passive: false }
    );
  }

  function onPicture(img, x, y) {
    var rect = img.getBoundingClientRect();
    if (!img.naturalWidth || !img.naturalHeight) return true;
    var scale = Math.min(rect.width / img.naturalWidth, rect.height / img.naturalHeight);
    var w = img.naturalWidth * scale;
    var h = img.naturalHeight * scale;
    var left = rect.left + (rect.width - w) / 2;
    var top = rect.top + (rect.height - h) / 2;
    return x >= left && x <= left + w && y >= top && y <= top + h;
  }

  function setOrigin(img, x, y) {
    var rect = img.parentElement.getBoundingClientRect();
    var ox = Math.max(0, Math.min(100, ((x - rect.left) / rect.width) * 100));
    var oy = Math.max(0, Math.min(100, ((y - rect.top) / rect.height) * 100));
    img.style.transformOrigin = ox + '% ' + oy + '%';
  }

  function unzoom() {
    if (!box) return;
    Array.prototype.forEach.call(box.querySelectorAll('.bb-lightbox__img.is-zoomed'), function (img) {
      img.classList.remove('is-zoomed');
    });
    box.classList.remove('is-zoomed');
    state.zoomed = false;
  }

  function updateCounter() {
    var counter = box.querySelector('[data-lb-counter]');
    var multiple = state.images.length > 1;
    counter.textContent = multiple ? state.index + 1 + ' / ' + state.images.length : '';
    box.querySelector('[data-lb-prev]').hidden = !multiple;
    box.querySelector('[data-lb-next]').hidden = !multiple;
  }

  function go(index, instant) {
    var track = box.querySelector('[data-lb-track]');
    var count = state.images.length;
    if (!count) return;
    unzoom();
    state.index = (index + count) % count;
    track.scrollTo({ left: state.index * track.clientWidth, behavior: instant ? 'auto' : 'smooth' });
    updateCounter();
  }

  function open(images, index, trigger) {
    if (!box) build();
    state.images = images;
    state.trigger = trigger;

    var track = box.querySelector('[data-lb-track]');
    track.innerHTML = images
      .map(function (img) {
        return (
          '<div class="bb-lightbox__slide">' +
          '<img class="bb-lightbox__img" src="' + hiRes(img) + '" alt="' + (img.getAttribute('alt') || '').replace(/"/g, '&quot;') + '" draggable="false">' +
          '</div>'
        );
      })
      .join('');

    box.hidden = false;
    document.documentElement.classList.add('bb-lightbox-open');
    go(index, true);
    box.querySelector('[data-lb-close]').focus();
  }

  function close() {
    if (!box || box.hidden) return;
    unzoom();
    box.hidden = true;
    document.documentElement.classList.remove('bb-lightbox-open');
    box.querySelector('[data-lb-track]').innerHTML = '';
    if (state.trigger) state.trigger.focus({ preventScroll: true });
  }

  var TRIGGER = 'media-gallery[data-bb-lightbox] .product__media-list .product-media-container.media-type-image';

  function triggerFrom(target) {
    var container = target.closest(TRIGGER);
    if (!container || container.closest('quick-add-modal')) return null;
    return container;
  }

  function openFrom(container) {
    var list = container.closest('.product__media-list');
    var images = [];
    var start = 0;
    Array.prototype.forEach.call(list.querySelectorAll('.product-media-container.media-type-image'), function (c) {
      var img = c.querySelector('.product__media img');
      if (!img) return;
      if (c === container) start = images.length;
      images.push(img);
    });
    if (images.length) open(images, start, container);
  }

  function decorate() {
    Array.prototype.forEach.call(document.querySelectorAll(TRIGGER), function (c) {
      if (c.closest('quick-add-modal') || c.classList.contains('bb-lightbox-trigger')) return;
      c.classList.add('bb-lightbox-trigger');
      c.setAttribute('tabindex', '0');
      c.setAttribute('role', 'button');
      c.setAttribute('aria-label', 'Open image viewer');
    });
  }

  document.addEventListener(
    'click',
    function (event) {
      var container = triggerFrom(event.target);
      if (!container) return;
      event.preventDefault();
      event.stopPropagation();
      openFrom(container);
    },
    true
  );

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    var container = event.target.classList && event.target.classList.contains('bb-lightbox-trigger') ? triggerFrom(event.target) : null;
    if (!container) return;
    event.preventDefault();
    openFrom(container);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', decorate);
  } else {
    decorate();
  }
  document.addEventListener('shopify:section:load', decorate);
  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      decorate();
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
